export const EMAIL_ACTIONS = {
    ADD: "ADD",
    FORWARD: "Forward",
    REPLY: "Reply",
    EDIT: "Edit",
    RESEND: "Resend"
}